export enum ERROR_TYPES {
  "INVALID_TOKEN",
  "USE_MOBILE_PERMISSION_FAIL",
  "WORKER_NOT_ONLINE"
}
